/**
 * @param {STRING} value 
 * @param {Boolean} lower 
 * @return {STRING} - example take - "ARKEN ZOO" , return - "Arken Zoo"
 */
export const capitalize = (value, lower = true) => {
    if (!value) return ''
    if(value?.length <= 3) return value
    let str = value.toString()
    str = lower ? str.toLowerCase() : str
    // be careful with symbol - & // need for H&M for example
    return str.replace(/(?:^|\s|&|["'([{])+\S/g, match => match.toUpperCase());
}
